import axios from "axios";
import { track } from "@/lib/ebook";
import { getRefCode } from "@/lib/referrals";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Start a Stripe checkout. Redirects on success. Throws on failure so the caller
 * can show a toast.
 *
 * @param {string} packageId — one of CHECKOUT_PACKAGES keys on the backend
 * @param {{email?:string, name?:string, source?:string}} opts
 */
export async function startCheckout(packageId, opts = {}) {
  track("checkout_start", packageId, { email: !!opts.email });
  const origin = window.location.origin;
  const ref_code = getRefCode();
  const metadata = {
    ...(opts.source ? { source: opts.source } : {}),
    ...(ref_code ? { ref_code } : {}),
  };
  const { data } = await axios.post(`${API}/checkout/session`, {
    package_id: packageId,
    origin_url: origin,
    email: opts.email,
    name: opts.name,
    metadata: Object.keys(metadata).length ? metadata : undefined,
  });
  if (!data?.url) throw new Error("No checkout URL returned");
  window.location.href = data.url;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await axios.get(`${API}/checkout/status/${sessionId}`);
  return data;
}
